export enum FilterStatus {
  OPEN = 'OPEN',
  RELEASED = 'RELEASED',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED',
}
